export default function formatPercentage(num) {
  return `${(num * 100).toFixed(2)}%`;
}
